<template>
  <div id="abstract-settings" class="custom-modal">
    <div class="modal-body no-footer">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-tabs tab-position="left" v-model="activeKey" @tab-click="changedTab">
            <el-tab-pane label="Genel" name="one">
              <AbstractPackages :data="abstract.packetIds" />
            </el-tab-pane>
            <el-tab-pane label="Sunum ve konular" name="two">
              <AbstractSubmission :data="abstract" />
            </el-tab-pane>
            <el-tab-pane label="Yazar bilgileri" name="three">
              <AbstractAuthors :data="abstract" />
            </el-tab-pane>
            <el-tab-pane label="Bildiri toplama yöntemi" name="four">
              <AbstractGeneralSettings :data="abstract" />
            </el-tab-pane>
            <el-tab-pane label="Ek sorular" name="five">
              <QuestionLibrary :id="null" v-if="activeKey == 'five'" :type="3" />
            </el-tab-pane>
            <el-tab-pane label="Bildiri detayları" name="six">
              <AbstractDetailSettings :data="abstract" v-if="activeKey == 'six'" />
            </el-tab-pane>
            <el-tab-pane label="Bildiri kuralları" name="seven">
              <AbstractRules :data="abstract" v-if="activeKey == 'seven'" />
            </el-tab-pane>
            <el-tab-pane label="Eleme ayarları" name="eight">
              <AbstractEvaluationSettings :data="abstract" v-if="activeKey == 'eight'" />
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </div>
    <!-- <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog');">Kapat</el-button>
        <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
          <el-button slot="reference" type="danger" icon="fas fa-trash"> Sil</el-button>
        </el-popconfirm>
      </div>
      <div class="right-buttons">
        <el-button type="primary" @click="updated">Kaydet</el-button>
      </div>
    </div> -->
  </div>
</template>

<script>
import AbstractPackages from './tabs/AbstractPackages.vue';
import AbstractSubmission from './tabs/AbstractSubmission.vue';
import AbstractAuthors from './tabs/AbstractAuthors.vue';
import AbstractGeneralSettings from './tabs/AbstractGeneralSettings.vue';
import QuestionLibrary from '../register-form/QuestionLibrary.vue';
import AbstractDetailSettings from './tabs/AbstractDetailSettings.vue';
import AbstractRules from './tabs/AbstractRules.vue';
import AbstractEvaluationSettings from './tabs/AbstractEvaluationSettings.vue';
export default {
  components: {
    AbstractPackages,
    AbstractSubmission,
    AbstractAuthors,
    AbstractGeneralSettings,
    QuestionLibrary,
    AbstractDetailSettings,
    AbstractRules,
    AbstractEvaluationSettings,
  },
  data() {
    return {
      abstract: {},
      activeKey: 'one',
    };
  },
  methods: {
    async changedTab() {
      var res = await this.$store.dispatch('abstractGet');
      this.abstract = res.data.data.item;
    },
    refreshList() {},
  },
  async created() {
    await this.$store.dispatch('getRegisterForm');
    var res = await this.$store.dispatch('abstractGet');
    this.abstract = res.data.data.item;
  },
};
</script>

<style lang="less" scoped>
#abstract-settings-dialog {
    .modal-body {
      min-height: calc(~"100vh - 239px");
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/abstract/AbstractSettings.vue